import { Component, OnInit } from '@angular/core';
import { LoginUrlService } from '../../services/login-url.service';

@Component({
  selector: 'app-http-status401',
  templateUrl: './http-status401.component.html',
  styleUrls: ['./http-status401.component.scss'],
})
export class HttpStatus401Component implements OnInit {
  constructor(private loginUrlService: LoginUrlService) { }

  ngOnInit(): void {
    if (this.loginUrlService.loginUrl) {
      window.location.href = this.loginUrlService.loginUrl;
    }
  }
}
